import { render } from "./email-verify.vue?vue&type=template&id=d8c48f3a"
import script from "./email-verify.vue?vue&type=script&lang=js"
export * from "./email-verify.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__